import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import RangeDatepicker from "src/components/RangeDatepicker";

type Props = {} & DateRangeProps;

type DateRangeProps = {
  dateRange: [Date | null, Date | null];
  onDateRangeChange: (dateRange: [Date | null, Date | null]) => void;
  disabled?: boolean;
  datePresetRanges?: PresetRange[];
};

const DateRangeFilter = (props: Props) => {
  const { dateRange, onDateRangeChange, disabled, datePresetRanges } = props;

  const handleDateRangeChange = (newDateRange: [Date | null, Date | null]) => {
    const [startDate, endDate] = newDateRange;

    const start = startDate ? moment(startDate).startOf("day").toDate() : null;
    const end = endDate ? moment(endDate).endOf("day").toDate() : null;

    onDateRangeChange([start, end]);
  };

  const handlePresetChipClick = (preset: PresetRange) => {
    // preset 클릭 시, preset.value 개월 전의 날짜를 계산하여 onDateRangeChange에 전달
    const start = moment().startOf("day").subtract(preset.value, "months").toDate();
    const end = moment().endOf("day").toDate();
    handleDateRangeChange([start, end]);

    // console.log(`${preset.label} preset clicked - Start: ${start}, End: ${end}`);
  };

  return (
    <div className="date-range-filter-container">
      <div className="range-datepicker-container">
        <RangeDatepicker dateRange={dateRange} onDateRangeChange={handleDateRangeChange} disabled={disabled} />
      </div>
      <RangePresetChips onPressPreset={handlePresetChipClick} datePresetRanges={datePresetRanges} />
    </div>
  );
};

type PresetRange = {
  label: string;
  value: number;
};

const PRESET_RANGE: PresetRange[] = [
  {
    label: "common:month1",
    value: 1,
  },
  {
    label: "common:month3",
    value: 3,
  },
  {
    label: "common:month6",
    value: 6,
  },
];

type RangePresetChipsProps = {
  datePresetRanges?: PresetRange[];
  disabled?: boolean;
  onPressPreset: (preset: PresetRange) => void;
};

const RangePresetChips = (props: RangePresetChipsProps) => {
  const { onPressPreset, datePresetRanges = PRESET_RANGE } = props;
  const { t } = useTranslation();
  const [selectedPreset, setSelectedPreset] = useState<PresetRange>();

  const onClickPreset = (preset: PresetRange) => {
    setSelectedPreset(preset);
    onPressPreset(preset);
  };

  return (
    <div className="range-preset-chips-container">
      {datePresetRanges.map((preset) => {
        const isSelected = selectedPreset?.value === preset.value;

        return (
          <button
            type="button"
            key={preset.label}
            className={`range-preset-chip ${isSelected ? "selected" : ""}`}
            onClick={() => {
              onClickPreset(preset);
            }}
          >
            <p>{t(preset.label)}</p>
          </button>
        );
      })}
    </div>
  );
};

export default DateRangeFilter;
